// src/redux/myStateSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  homepageCodieQuestion: null, 
};

const myStateSlice = createSlice({
  name: "codieStateofHomepage",
  initialState,
  reducers: {
    setHomepageCodieQuestion: (state, action) => {
      state.homepageCodieQuestion = action.payload;
    },
    resetHomepageCodieQuestion: (state) => {
      state.homepageCodieQuestion = null;
    },
  },
});

export const { setHomepageCodieQuestion, resetHomepageCodieQuestion } = myStateSlice.actions;
export default myStateSlice.reducer;
